import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULT_CONTENT = {
  lead: '色紙・掛軸・パネル・額装・命名書・ロゴ制作など、各種オーダーメイド作品を承っております。',
  items: [
    { name: '色紙', price: '3,000円〜', lead: '3日〜1週間' },
    { name: '命名書（色紙/奉書）', price: '3,000円〜', lead: '3日〜1週間' },
    { name: 'パネル作品', price: '5,000円〜', lead: '1ヶ月以上' },
    { name: '掛軸', price: '10,000円〜', lead: '1ヶ月以上' },
    { name: '額装作品', price: '30,000円〜', lead: 'ご相談' },
    { name: '社名ロゴ・商用ロゴ等', price: '50,000円〜', lead: 'ご相談' },
  ],
  note: '価格・納期は作品サイズや制作内容により異なります。詳細はお問い合わせください。',
};

export default function OrderSection() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'siteContent', 'order'), (snap) => {
      if (snap.exists()) setContent({ ...DEFAULT_CONTENT, ...snap.data() });
    });
    return unsubscribe;
  }, []);

  return (
    <section id="order" className="pf-section pf-order">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">ORDER</p>
        <h2 className="pf-section__title">オーダー</h2>
        <p className="pf-section__lead">{content.lead}</p>
      </div>

      <div className="pf-order__table">
        {content.items.map((i, idx) => (
          <div key={idx} className="pf-order__row">
            <span className="pf-order__name">{i.name}</span>
            <span className="pf-order__price">{i.price}</span>
            <span className="pf-order__lead">納期：{i.lead}</span>
          </div>
        ))}
      </div>

      <p className="pf-order__note">{content.note}</p>
    </section>
  );
}
